import PropTypes from "prop-types";

export const props = {
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};
